import { asText } from "@prismicio/helpers";
import type { BlockOfTextWithHeader2ColumnSlice } from "prismicio-types";
import { SliceComponentProps } from "@prismicio/react";
import { useMemo } from "react";
import { wrapIframe } from "@commercekit/shared";

const BlockOfTextWithHeader2Column = ({
  slice,
}: SliceComponentProps<BlockOfTextWithHeader2ColumnSlice>) => {
  const content = useMemo(() => {
    return {
      column_one: wrapIframe(asText(slice.primary.column_one)),
      column_two: wrapIframe(asText(slice.primary.column_two)),
    };
  }, [slice.primary.column_one]);

  return (
    <div className="col-12 px-0">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {slice.primary.header.length > 0 && (
            <h1 className="heading strong xl underlined left pb-3 mb-3">
                {asText(slice.primary.header)}
              </h1>
            )}
          </div>
          <div className="col-12 col-md-6 pr-lg-4 pr-xl-5 ">
            <div
              className="content"
              dangerouslySetInnerHTML={{
                __html: content.column_one || "",
              }}
            ></div>
          </div>
          <div className="col-12 col-md-6 pr-lg-4 pr-xl-5 ">
            <div
              className="content"
              dangerouslySetInnerHTML={{
                __html: content.column_two || "",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlockOfTextWithHeader2Column;
